import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { View3dService } from 'src/app/shared/services/view3d.service';

@Component({
  selector: 'app-view3d-dialog',
  templateUrl: './view3d-dialog.component.html',
  styleUrls: ['./view3d-dialog.component.scss'],
})
export class View3dDialogComponent {
  model3dId!: string;
  title!: string;
  id?: string; 


  constructor(public bsModalRef: BsModalRef) {}
}
